/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParams,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoice400,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoice401,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoice500,
} from "../../types/individualPaymentInvoicesController/PostApiV1IndividualpaymentParcelsParcelidCancelInvoice.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidCancelInvoice } from "../../clients/individualPaymentInvoicesController/postApiV1IndividualpaymentParcelsParcelidCancelInvoice.ts";

export const postApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationKey =
  () =>
    [
      { url: "/api/v1/individualpayment/parcels/:parcelId/cancel-invoice" },
    ] as const;

export type PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationKey
  >;

export function postApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice400
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice401
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId, params }) => {
      return postApiV1IndividualpaymentParcelsParcelidCancelInvoice(
        parcelId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Marca a NF como cancelada; com 'reversePayment=true' estorna o pagamento (parcela paga volta a pendente). Migrado do legado IndividualPayment/CancelInvoice. **(Requer Authorization para autenticação)**
 * @summary Cancela a nota fiscal da parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/cancel-invoice}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidCancelInvoice<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice400
        | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice401
        | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams["parcelId"];
        params?: PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice400
        | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice401
        | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams["parcelId"];
        params?: PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParams;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice400
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice401
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice400
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice401
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParams;
    },
    TContext
  >;
}
